import React, { useState, useContext } from 'react';
import { FaTimes, FaCloudUploadAlt, FaPlus, FaTrash } from 'react-icons/fa';
import AppContext from '../../../context/AppContext';
import { Button, Form, Row, Col } from 'react-bootstrap';
import axios from 'axios'; 
import '../../../assets/css/admin/adminPackageManagement/admaddpackages.css';

const AddPackageModal = ({ onClose, onSuccess }) => {
    const { baseUrl, authToken } = useContext(AppContext);
    const [packageName, setPackageName] = useState('');
    const [packageDestination, setPackageDestination] = useState('');
    const [location, setLocation] = useState('');
    const [packageCategory, setPackageCategory] = useState('');
    const [packagePrice, setPackagePrice] = useState('');
    const [durationDays, setDurationDays] = useState('');
    const [durationNights, setDurationNights] = useState('');
    const [maxPeopleSize, setMaxPeopleSize] = useState('');
    const [packageDescription, setPackageDescription] = useState('');
    const [packageStatus, setPackageStatus] = useState('draft');
    const [isAvailable, setIsAvailable] = useState(true);
    const [inclusions, setInclusions] = useState(['']);
    const [exclusions, setExclusions] = useState(['']);
    const [itinerary, setItinerary] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [newTitle, setNewTitle] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [date, setDate] = useState('');

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImageFile(file);
        const reader = new FileReader();
        reader.onloadend = () => setImagePreview(reader.result);
        reader.readAsDataURL(file);
    };

    const submitPackage = () => {
        setLoading(true);
        
        const formData = new FormData();
        formData.append('jjsubadmin_id', 1);
        formData.append('package_name', packageName);
        formData.append('package_destination', packageDestination);
        formData.append('location', location);
        formData.append('package_category', packageCategory);
        formData.append('package_price', packagePrice);
        formData.append('duration_days', durationDays);
        formData.append('duration_nights', durationNights);
        formData.append('max_people_size', maxPeopleSize);
        formData.append('package_date',date);
        formData.append('package_description', packageDescription);
        formData.append('package_status', packageStatus);
        formData.append('is_available', isAvailable ? 1 : 0);
        formData.append('package_inclusion', JSON.stringify(inclusions.filter(i => i.trim() !== '')));
        formData.append('package_exclusion', JSON.stringify(exclusions.filter(i => i.trim() !== '')));
        formData.append('package_itinerary', JSON.stringify(itinerary));
        if (imageFile) formData.append('package_image', imageFile);

        axios.post(`${baseUrl}/admin/travel-packages-set`, formData, {
            headers: { 
                "Authorization": `Bearer ${authToken}`,
                "Content-Type": "multipart/form-data" 
            }
        }) 
        .then((response) => {
            setLoading(false);
            if (response.data.success) {
                if (onSuccess) onSuccess();
                onClose();
            } else {
                alert(response.data.message || 'Something went wrong');
            }
        })
        .catch((error) => {
            setLoading(false);
            console.error('Add package error:', error);
            alert('Unable to connect to server');
        });
    };

    const addItineraryDay = () => {
        if (newTitle && newDescription) {
            const newDay = {
                day: itinerary.length + 1,
                title: newTitle,
                description: newDescription
            };
            setItinerary([...itinerary, newDay]);
            setNewTitle('');
            setNewDescription('');
        } else {
            alert('Please enter both title and description');
        }
    };

    return (
        <div className="adm-modal-overlay" onClick={onClose}>
            <div className="adm-modal-container adm-add-package-modal" onClick={(e) => e.stopPropagation()}>
                <div className="adm-modal-header">
                    <div>
                        <h2 className="adm-modal-title">Add New Package</h2>
                        <p className="adm-modal-subtitle">Create a new travel package</p>
                    </div>
                    <button className="adm-modal-close" onClick={onClose} disabled={loading}>
                        <FaTimes />
                    </button>
                </div>

                <div className="adm-modal-body adm-package-form">
                    <div className="adm-form-section">
                        <h3 className="adm-form-section-title">Package Image</h3>
                        <div className="adm-image-upload-area">
                            {imagePreview ? (
                                <div className="adm-image-preview">
                                    <img src={imagePreview} alt="Preview" />
                                    <button type="button" className="adm-remove-inclusion" onClick={() => { setImagePreview(null); setImageFile(null); }}>
                                        <FaTrash /> Remove
                                    </button>
                                </div>
                            ) : (
                                <label className="adm-upload-label">
                                    <FaCloudUploadAlt className="adm-upload-icon" />
                                    <span>Click to upload image</span>
                                    <small>JPG, PNG — max 2MB</small>
                                    <input type="file" accept="image/jpeg,image/png" onChange={handleImageChange} style={{ display: 'none' }} />
                                </label>
                            )}
                        </div>
                    </div>
             
                    <div className="adm-form-section">
                         <h3 className="adm-form-section-title">Basic Information</h3>
                         <Row>
                            <Col md={6}><Form.Group className="mb-3">
                            <Form.Label>Package Name *</Form.Label>
                            <Form.Control 
                                type="text" 
                                placeholder="e.g., Hunza Valley Adventure" 
                                value={packageName} 
                                onChange={(e) => setPackageName(e.target.value)} 
                            />
                        </Form.Group></Col>

                         <Col md={6}><Form.Group className="mb-3">
                            <Form.Label>Departure Date *</Form.Label>
                            <Form.Control 
                                type="date" 
                                placeholder="e.g., enter Date" 
                                value={date} 
                                onChange={(e) => setDate(e.target.value)} 
                            />
                        </Form.Group></Col>
                       
                        
                    </Row>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Category</Form.Label>
                                    <Form.Select value={packageCategory} onChange={(e) => setPackageCategory(e.target.value)}>
                                        <option value="">Select Category</option>
                                        <option value="Adventure">Adventure</option>
                                        <option value="Family">Family</option>
                                        <option value="Honeymoon">Honeymoon</option>
                                        <option value="City Tour">City Tour</option>
                                        <option value="Winter">Winter</option>
                                        <option value="Beach">Beach</option>
                                        <option value="Cultural">Cultural</option>
                                        <option value="Religious">Religious</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Price (PKR) *</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        placeholder="e.g., 45000" 
                                        value={packagePrice} 
                                        onChange={(e) => setPackagePrice(e.target.value)} 
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Destination</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="e.g., Hunza Valley" 
                                        value={packageDestination} 
                                        onChange={(e) => setPackageDestination(e.target.value)} 
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        placeholder="e.g., Gilgit-Baltistan" 
                                        value={location} 
                                        onChange={(e) => setLocation(e.target.value)} 
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Duration Days</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        placeholder="Days" 
                                        value={durationDays} 
                                        onChange={(e) => setDurationDays(e.target.value)} 
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Duration Nights</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        placeholder="Nights" 
                                        value={durationNights} 
                                        onChange={(e) => setDurationNights(e.target.value)} 
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Max People</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        placeholder="Max capacity" 
                                        value={maxPeopleSize} 
                                        onChange={(e) => setMaxPeopleSize(e.target.value)} 
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>

                    <div className="adm-form-section">
                        <h3 className="adm-form-section-title">Description</h3>
                        <Form.Control 
                            as="textarea" 
                            rows={4} 
                            placeholder="Detailed description of the package..." 
                            value={packageDescription} 
                            onChange={(e) => setPackageDescription(e.target.value)} 
                        />
                    </div>

                    <div className="adm-form-section">
                        <h3 className="adm-form-section-title">Inclusions</h3>
                        {inclusions.map((item, index) => (
                            <div key={index} className="adm-inclusion-item mb-2">
                                <Form.Control 
                                    type="text" 
                                    placeholder="e.g., Hotel Accommodation" 
                                    value={item} 
                                    onChange={(e) => { 
                                        const updated = [...inclusions]; 
                                        updated[index] = e.target.value; 
                                        setInclusions(updated); 
                                    }} 
                                />
                                {inclusions.length > 1 && (
                                    <Button variant="danger" size="sm" onClick={() => setInclusions(inclusions.filter((_, i) => i !== index))}>
                                        <FaTrash />
                                    </Button>
                                )}
                            </div>
                        ))}
                        <Button variant="success" size="sm" onClick={() => setInclusions([...inclusions, ''])} className="mt-2">
                            <FaPlus /> Add Inclusion
                        </Button>
                    </div>

                    <div className="adm-form-section">
                        <h3 className="adm-form-section-title">Exclusions</h3>
                        {exclusions.map((item, index) => (
                            <div key={index} className="adm-inclusion-item mb-2">
                                <Form.Control 
                                    type="text" 
                                    placeholder="e.g., Airfare" 
                                    value={item} 
                                    onChange={(e) => { 
                                        const updated = [...exclusions]; 
                                        updated[index] = e.target.value; 
                                        setExclusions(updated); 
                                    }} 
                                />
                                {exclusions.length > 1 && (
                                    <Button variant="danger" size="sm" onClick={() => setExclusions(exclusions.filter((_, i) => i !== index))}>
                                        <FaTrash />
                                    </Button>
                                )}
                            </div>
                        ))}
                        <Button variant="success" size="sm" onClick={() => setExclusions([...exclusions, ''])} className="mt-2">
                            <FaPlus /> Add Exclusion
                        </Button>
                    </div>

                    <div className="adm-form-section">
                        <h3 className="adm-form-section-title">Itinerary (Optional)</h3>
                        {itinerary.length > 0 && (
                            <div className="mb-3">
                                {itinerary.map((day, index) => (
                                    <div key={index} className="adm-inclusion-item mb-2">
                                        <Form.Control 
                                            readOnly 
                                            value={`Day ${day.day}: ${day.title}`} 
                                        />
                                        <Button variant="danger" size="sm" onClick={() => {
                                            const filtered = itinerary.filter((_, i) => i !== index);
                                            const renumbered = filtered.map((item, idx) => ({ ...item, day: idx + 1 }));
                                            setItinerary(renumbered);
                                        }}>
                                            <FaTrash />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        )}
                        <Row>
                            <Col md={12}>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Day Title (e.g., Arrival in Hunza)" 
                                    value={newTitle} 
                                    onChange={(e) => setNewTitle(e.target.value)} 
                                    className="mb-2"
                                />
                            </Col>
                            <Col md={12}>
                                <Form.Control 
                                    as="textarea" 
                                    rows={2} 
                                    placeholder="Day Description" 
                                    value={newDescription} 
                                    onChange={(e) => setNewDescription(e.target.value)} 
                                    className="mb-2"
                                />
                            </Col>
                            <Col md={12}>
                                <Button variant="primary" onClick={addItineraryDay} className="mt-2">
                                    <FaPlus /> Add Day to Itinerary
                                </Button>
                            </Col>
                        </Row>
                    </div>

                    <div className="adm-form-section">
                        <h3 className="adm-form-section-title">Settings</h3>
                        <Row>
                            <Col md={6}>
                                <Form.Check 
                                    type="checkbox" 
                                    label="Package Available" 
                                    checked={isAvailable} 
                                    onChange={(e) => setIsAvailable(e.target.checked)} 
                                    className="mb-3" 
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Form.Select value={packageStatus} onChange={(e) => setPackageStatus(e.target.value)}>
                                 <option value="draft">Draft</option>
                                 <option value="published">Published</option>
                                 <option value="archived">Archived</option>
                                </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="adm-modal-footer">
                    <Button variant="secondary" onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={submitPackage} disabled={loading}>
                        {loading ? 'Adding...' : 'Add Package'}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AddPackageModal;